import React from 'react';
import Icon from '../../../components/AppIcon';

const tabs = [
  { id: 'overview', label: 'Overview', icon: 'User' },
  { id: 'services', label: 'Services', icon: 'Briefcase' },
  { id: 'portfolio', label: 'Portfolio', icon: 'Image' },
  { id: 'reviews', label: 'Reviews', icon: 'Star' },
];

const ProfileTabs = ({ activeTab, onTabChange }) => {
  return (
    <div className="flex gap-1 p-1 rounded-xl" style={{ background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(0,212,255,0.1)' }}>
      {tabs?.map((tab) => {
        const isActive = activeTab === tab?.id;
        return (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className="flex-1 flex items-center justify-center gap-2 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200"
            style={{
              background: isActive ? 'linear-gradient(135deg, rgba(0,212,255,0.2), rgba(0,153,204,0.2))' : 'transparent',
              color: isActive ? '#00D4FF' : '#6B9EC4',
              border: isActive ? '1px solid rgba(0,212,255,0.3)' : '1px solid transparent',
            }}
          >
            <Icon name={tab?.icon} size={15} />
            <span className="hidden sm:inline">{tab?.label}</span>
          </button>
        );
      })}
    </div>
  );
};

export default ProfileTabs;
